const costSettingsLinks: any[] = [];
export default costSettingsLinks;
